import React, { useRef, FC, ElementType, ReactElement } from 'react';
import { RegularButton } from 'fronton-react';
import { styled } from 'linaria/react';

export const DATA_QA_CAROUSEL_ITEM = 'carousel-item';

const StyledButton = styled(RegularButton)`
	height: 100%;
	text-decoration: none;
`;

type ItemProps = {
	children: ReactElement;
	className?: string;
	href?: string;
	variant: 'primary' | 'secondary' | 'outline' | 'pseudo';
	as?: ElementType;
	data?: { idx: number; elementBlock: string };
	onItemIntersect?: (idx: number) => void;
	withoutAnalytics?: boolean;
};

export const CarouselItem: FC<ItemProps> = ({ children, className, href, variant, as = 'a' }) => {
	const carouselItemRef = useRef<HTMLDivElement | null>(null);

	return (
		<StyledButton
			ref={carouselItemRef}
			as={as}
			variant={variant}
			href={href}
			className={className}
			data-qa={DATA_QA_CAROUSEL_ITEM}
		>
			{children}
		</StyledButton>
	);
};
